import { get } from "shared/wrapper";

class DevicesRepository {
  URL = "/api/codeMaps/v1";

  constructor(url) {
    this.URL = url || this.URL;
  }

  findAll(params) {
    return get(`${this.URL}`, params);
  }

  findOne(uid) {
    return get(`${this.URL}`, { uid: uid });
  }
}

export default new DevicesRepository();
